<template>
  <a class="relative w-full mb-12 flex flex-col bg-primary/60 rounded hover:scale-105 hover:shadow cursor-pointer transition-all" @click="$emit('click')">
    <div class="flex-grow w-full bg-primary rounded-t overflow-hidden flex-shrink-0">
      <div v-if="img" :style="{ backgroundImage: `url(${img})` }" class="bg-cover bg-center w-full aspect-[3/2]" />
      <div v-else class="w-full inset-0 flex items-center justify-center aspect-[3/2] bg-action p-2">
        <h4 class="font-semibold text-action text-lg text-center">{{ title }}</h4>
      </div>
    </div>

    <div class="h-full w-full pt-5 text-secondary flex flex-col justify-between p-3">
      <div>
        <h4 class="font-semibold mb-1">{{ title }}</h4>
        <p class="text-sm mb-3" v-html="info" />
        <p>{{ price }}</p>
      </div>

      <b-button variant="action" class="w-full mt-4 flex-shrink-0">
        <span class="line-clamp-1">{{ label }}</span>
      </b-button>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null
    },
    img: {
      type: String,
      default: null
    },
    info: {
      type: String,
      default: null
    },
    price: {
      type: String,
      default: null
    },
    to: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: 'Buy now'
    }
  }
}
</script>